import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SVG from 'components/base/SVG';
import css from './style.scss';

/**
 * LoadingButton component with loading state support
 * Shows a white spinner inside the button when loading
 * Supports rose-300 color for delete actions
 */
const LoadingButton = ({
  loading,
  disabled,
  onClick,
  className,
  children,
  variant = 'rose', // 'rose' for rose-300 (delete), 'teal' for teal-300,
  isLarge,
  ...rest
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      {...rest}
      className={classNames(
        css.loadingButton,
        {
          [css.loadingButtonRose]: variant === 'rose',
          [css.loadingButtonTeal]: variant === 'teal',
          [css.loadingButtonLoading]: loading,
          [css.loadingButtonLarge]: isLarge,
          [css.disabledBtn]: isDisabled,
        },
        className
      )}
      onClick={onClick}
      disabled={isDisabled}
    >
      <div className={css.loadingButtonContent}>
        {children}
      </div>
      {loading && (
        <div className={
          classNames(
            css.loadingButtonSpinner,
            {
              [css.loadingButtonSpinnerLarge]: isLarge,
            },
          )
        }>
          <SVG icon="spinner" />
        </div>
      )}
    </button>
  );
};

LoadingButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['rose', 'teal']),
  isLarge: PropTypes.bool,
};

LoadingButton.defaultProps = {
  loading: false,
  disabled: false,
  variant: 'rose',
  isLarge: false,
};

export default LoadingButton;

